import React, { useEffect, useState } from "react";

const API = "/api/retentiondays";

export default function RetentionDays() {
  const [days, setDays] = useState(3);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState("");

  useEffect(() => {
    loadSettings();
  }, []);

  async function loadSettings() {
    try {
      setLoading(true);

      const res = await fetch(API);
      const data = await res.json();

      if (data.success) {
        setDays(data.settings.retentionDays ?? 2);
      }
    } catch (err) {
      setMessage("Unable to load settings.");
    } finally {
      setLoading(false);
    }
  }

  async function saveSettings() {
    if (days < 1 || days > 365) {
      setMessage("Retention days must be between 1 and 365.");
      return;
    }

    try {
      setSaving(true);

      const res = await fetch(API, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
            retentionDays: Number(days),
        }),
      });

      const data = await res.json();

      if (data.success) {
        setMessage("Settings saved successfully.");
      } else {
        setMessage(data.error);
      }
    } catch {
      setMessage("Unable to save settings.");
    } finally {
      setSaving(false);
    }
  }

  return (
    <div className="p-6 text-white">

      <h1 className="text-3xl font-bold mb-8">
        Retention Days Settings
      </h1>

      <div className="bg-[#1e293b] rounded-xl p-6 max-w-xl">

        <h2 className="text-xl font-semibold mb-6">
          Stocks Data
        </h2>

        <div className="mb-2">
          Retention Days
        </div>

        <input
          type="number"
          min="1"
          max="365"
          value={days}
          onChange={(e) => setDays(e.target.value)}
          className="w-full p-3 rounded bg-[#0f172a] border border-gray-600"
        />

        <p className="text-gray-400 mt-3">
          Automatically delete stock history older than the selected number of days.
        </p>

        <button
          onClick={saveSettings}
          disabled={saving || loading}
          className="mt-8 bg-blue-600 hover:bg-blue-700 px-6 py-3 rounded-lg"
        >
          {saving ? "Saving..." : "Save"}
        </button>

        {message && (
          <div className="mt-5 text-green-400">
            {message}
          </div>
        )}

      </div>

    </div>
  );
}